import { string } from 'yup'
import {
  aldigroupscore,
  aldiregionranking,
  bloomsmonthly,
  bloomsvenue,
  bscpdf,
  calenderreport,
  categorylist,
  categoryreport,
  complimentreport,
  createChecklist,
  createChecklistQuestion,
  custommonthreport,
  dashboard,
  deleteChecklist,
  deleteChecklistQuestion,
  deletePhotos,
  financialreport,
  fixitlist,
  forgotpassword,
  getChecklist,
  getClientDbName,
  getcliententityid,
  getreportlist,
  gettemptoken,
  gettrenddata,
  groupreport,
  monthlyComparisons,
  monthlyreport,
  monthlysitereport,
  questionsummaryreport,
  regionvenues,
  scorecardlist,
  scorecardPDF,
  sendOtp,
  sitesummary,
  starrating,
  starrating2,
  starratingcomparision,
  starratingperformance,
  updateChecklist,
  updateChecklistQuestion,
  uploadfiles,
  usersLogin,
  venueChecklist,
  veneuAdmin,
  veneuLogins,
  venuelist,
  venueperformance,
  verifyOtp,
  ytdreport,
  answeredQuestions,
  createveneuLogins,
  updateveneuLogins,
  venueByvenueId,
  getRegionByClientEntity,
  putUpdateVenue,
  deletveneuLogins,
  putAreaManager,
  getAreaManagers,
  postAreaManager,
  createfeedbackquestions,
  getfeedbackquestions,
  updatefeedbackquestions,
  submitfeedbackanswers,
  downloadexcel,
  generatelogintoken,
  downloadfeedbackexcel,
  categoryComparisionReport,
  updatefixit,
  downloadcategoryexcel,
  deletefeedbackquestions,
  siteComparisionReport,
  submitclientcomment,
  chatboat,
  deleteAreaManager,
  categoryWeeklyComparisonReport,
  siteWeeklyComparisonReport,
  dataExplorer,
  starratingforvenue,
  starratingforvenue2,
  getBusinessChecklist,
  createBusinessChecklist,
  updateBusinessChecklist,
  getBusinessChecklistQuestions,
  createBusinessChecklistQuestion,
  updateBusinesssChecklistQuestion,
  deleteBusinessChecklistQuestion,
  getChecklistQuestions,
  getChecklistCategorylist,
  getChecklistTemplateListing,
  getCheklistSubmissionQuestions,
  getVenueManagerCheklistList,
  createChecklistSubmission,
  submitVenueChecklist,
  getChecklistSubmissonList,
  getChecklistDashboard,
  getAreaChecklistDashboard,
  checkListCreation,
  scorebyCategory,
  duechecklist,
  scoreTrend,
  starRatingSummary,
  lowScoringQuestions,
  venueDashboard,
  categoryHeatMap,
  recentReports,
  checklisttemplatequestions,
  scoreDistribusion,
  checklistpdf,
  newVenuePdf,
  npsscore,
  annualreport,
  newClientPdf,
  clientannualreport,
  starRatingAverage,
  venueLeaderBoard,
  venueLeaderBoardDetails,
  categoryScores,
  questionlistforBusiness,
  resend2FA,

} from './ApiEndPoint'
import { baseApiCall } from './BaseApiCall'
import storage from '../../utils/storage'

export const ApiUsersLogin = (data: any) => {
  return baseApiCall({
    url: usersLogin,
    method: 'post',
    data
  })
}
export const ApiGetClientEntityId = (data: any) => {
  return baseApiCall({
    url: `${getcliententityid}?clientId=${data}`,
    method: 'get',
  })
}
export const ApiGetClientDbName = () => {
  return baseApiCall({
    url: getClientDbName,
    method: 'get'
  })
}
export const ApiGetGroupReport = (data: any) => {
  return baseApiCall({
    url: groupreport + data,
    method: 'get'
  })
}

export const ApiGetMonthlyComparison = (data: any) => {
  return baseApiCall({
    url: monthlyComparisons + data,
    method: 'get',
    responseType: 'blob',
    fullResponse: true

  })
}
export const ApiGetVenueList = (clientEntityId: number, regionId?: string) => {
  return baseApiCall({
    url: `${venuelist}?clientEntityId=${clientEntityId}${regionId && regionId.length > 1 ? `&regionId=${Number(regionId)}` : ''}${storage.getItem('areaId') ? `&areaId=${storage.getItem('areaId')}` : ''}`,
    method: 'get'
  })
}
export const ApiGetVenueAdminData = (data: any) => {
  return baseApiCall({
    url: veneuAdmin + data,
    method: 'get'
  })
}

export const ApiGetCategoryList = (clientEntityId: number) => {
  return baseApiCall({
    url: `${categorylist}?clientEntityId=${clientEntityId}${storage.getItem('areaId') ? `&areaId=${storage.getItem('areaId')}` : ''}`,
    method: 'get'
  })
}
export const ApiGetStarRating = (data: any) => {
  return baseApiCall({
    url: `${starrating}?${(data.categoryId) !== " " ? `categoryId=${data.categoryId}&` : ''}clientEntityId=${data.clientEntityId}&s_year=${data.s_year}&s_month=${data.s_month}&e_year=${data.e_year}&e_month=${data.e_month}${storage.getItem('areaId') ? `&areaId=${storage.getItem('areaId')}` : ''}`,
    method: 'get'
  })
}
export const ApiGetStarRating2 = (data: any) => {
  return baseApiCall({
    url: `${starrating2}?${(data.categoryId) !== " " ? `categoryId=${data.categoryId}&` : ''}clientEntityId=${data.clientEntityId}&s_year=${data.s_year}&s_month=${data.s_month}&e_year=${data.e_year}&e_month=${data.e_month}${storage.getItem('areaId') ? `&areaId=${storage.getItem('areaId')}` : ''}`,
    method: 'get'
  })
}

export const ApiGetStarRatingForVenue = (data: any) => {
  return baseApiCall({
    url: `${starratingforvenue}?${(data.categoryId) !== " " ? `categoryId=${data.categoryId}&` : ''}clientEntityId=${data.clientEntityId}&s_year=${data.s_year}&s_month=${data.s_month}&e_year=${data.e_year}&e_month=${data.e_month}${storage.getItem('areaId') ? `&areaId=${storage.getItem('areaId')}` : ''}${data.venueId ? `&venueId=${data?.venueId}`: ""}`,
    method: 'get'
  })
}
export const ApiGetStarRatingForVenue2 = (data: any) => {
  return baseApiCall({
    url: `${starratingforvenue2}?${(data.categoryId) !== " " ? `categoryId=${data.categoryId}&` : ''}clientEntityId=${data.clientEntityId}&s_year=${data.s_year}&s_month=${data.s_month}&e_year=${data.e_year}&e_month=${data.e_month}${storage.getItem('areaId') ? `&areaId=${storage.getItem('areaId')}` : ''}${data.venueId ? `&venueId=${data?.venueId}`: ""}`,
    method: 'get'
  })
}
export const ApiGroupMonthReport = (data: any) => {
  return baseApiCall({
    url: `${custommonthreport}?s_year=${data.s_year}&s_month=${data.s_month}&e_year=${data.e_year}&e_month=${data.e_month}&clientEntityId=${data.clientEntityId}${data.regionId ? `&regionId=${data.regionId}` : ''}${storage.getItem('areaId') || data.areaId ? `&areaId=${data?.areaId ?? storage.getItem('areaId')}` : ''}`,
    method: 'get'
  })
}
export const ApiSiteSummary = (data: any) => {
  return baseApiCall({
    url: `${sitesummary}?month=${data.month}&venueId=${data.venueId}&clientEntityId=${data.clientEntityId}${storage.getItem('areaId') ? `&areaId=${storage.getItem('areaId')}` : ''}`,
    method: 'get'
  })
}
export const ApiQuestionSummaryReport = (data: any) => {
  return baseApiCall({
    url: `${questionsummaryreport}?s_year=${data.s_year}&s_month=${data.s_month}&e_year=${data.e_year}&e_month=${data.e_month}&clientEntityId=${data.clientEntityId}${data.regionId ? `&regionId=${data.regionId}` : ''}${data.venueId ? `&venueId=${data.venueId}` : ''}${(storage.getItem('areaId') || data.areaId) ? `&areaId=${ data.areaId ?? storage.getItem('areaId')}` : ''}`,
    method: 'get'
  })
}
export const ApiDashboard = (data: any) => {
  return baseApiCall({
    url: dashboard + data,
    method: 'get'
  })
}
export const ApiVenuePerformance = (data: any) => {
  return baseApiCall({
    url: venueperformance + data,
    method: 'get'
  })
}
export const ApiGetFixitList = (data: any) => {
  return baseApiCall({
    url: fixitlist + data,
    method: 'get'
  })
}
export const ApiGetScorecardList = (data: any) => {
  return baseApiCall({
    url: scorecardlist + data,
    method: 'get'
  })
}
export const ApiSendOtp = (data: any) => {
  return baseApiCall({
    url: sendOtp,
    method: 'post',
    data
  })
}
export const ApiVerifyOtp = (data: any) => {
  return baseApiCall({
    url: verifyOtp,
    method: 'post',
    data
  })
}
export const ApiResetPassword = (data: any) => {
  return baseApiCall({
    url: forgotpassword,
    method: 'post',
    data
  })
}
export const ApiStarRatingPerformance = (data: any) => {
  return baseApiCall({
    url: starratingperformance + data,
    method: 'get',
  })
}
export const ApiStarRatingComparision = (data: any) => {
  return baseApiCall({
    url: starratingcomparision + data,
    method: 'get',
  })
}
export const ApiYTDReport = (data: any) => {
  return baseApiCall({
    url: ytdreport + data,
    method: 'get',
  })
}
export const ApiRegionVenues = (data: any) => {
  if (storage.getItem('ClientGroupName') === 'ALDI') return baseApiCall({
    url: regionvenues + data,
    method: 'get',
  })
}
export const ApiAldiGroupScore = (data: any) => {
  return baseApiCall({
    url: aldigroupscore + data,
    method: 'get',
  })
}
export const ApiAldiRegionRanking = (data: any) => {
  return baseApiCall({
    url: aldiregionranking + data,
    method: 'get',
  })
}
export const ApiMonthlyReport = (data: any) => {
  return baseApiCall({
    url: monthlyreport + data,
    method: 'get',
    responseType: 'blob',
    fullResponse: true
  })
}
export const ApiCalenderReport = (data: any) => {
  return baseApiCall({
    url: calenderreport + data,
    method: 'get',
    responseType: 'blob',
    fullResponse: true
  })
}
export const ApiFinancialReport = (data: any) => {
  return baseApiCall({
    url: financialreport + data,
    method: 'get',
    responseType: 'blob',
    fullResponse: true
  })
}
export const ApiAnnualReport = (data: any) => {
  return baseApiCall({
    url: annualreport + data,
    method: 'get',
    responseType: 'blob',
    fullResponse: true
  })
}
export const ApiClientAnnualReport = (data: any) => {
  return baseApiCall({
    url: clientannualreport + data,
    method: 'get',
    responseType: 'blob',
    fullResponse: true
  })
}
export const ApiScoreCardPDF = (data: any) => {
  return baseApiCall({
    url: scorecardPDF + data,
    method: 'get',
  })
}
export const ApiScoreCardPDF2 = (data: any) => {
  return baseApiCall({
    url: scorecardPDF + data,
    method: 'get',
    responseType: 'blob',
    fullResponse: true
  })
}
export const ApiBSCPDF = (data: any) => {
  return baseApiCall({
    url: bscpdf + data,
    method: 'get',
    responseType: 'text'

  })
}
export const ApiGetCategoryReport = (data: any) => {
  return baseApiCall({
    url: categoryreport + data,
    method: 'get',
  })
}
export const ApiGetTrendData = (data: any) => {
  return baseApiCall({
    url: gettrenddata + data,
    method: 'get',
    responseType: 'blob'
  })
}
export const ApiGetDataExplorer = (data: any) => {
  return baseApiCall({
    url: dataExplorer + data,
    method: 'get',
    responseType: 'blob'
  })
}

export const ApiComplimentReport = (data: any) => {
  return baseApiCall({
    url: complimentreport + data,
    method: 'get',
  })
}

export const ApiDeletePhotos = (data: any) => {
  return baseApiCall({
    url: deletePhotos,
    method: 'Delete',
    data
  });
}
export const ApiGetReportlist = (data: any) => {
  return baseApiCall({
    url: getreportlist + data,
    method: 'get',
  });
}
export const ApiGetTempToken = (data: any) => {
  return baseApiCall({
    url: gettemptoken,
    method: 'post',
    data
  });
}

export const ApiGetMonthlySiteReport = (data: any) => {
  return baseApiCall({
    url: monthlysitereport + data,
    method: 'get',
  })
}
export const ApiBloomsPDF = (data: any) => {
  return baseApiCall({
    url: bloomsmonthly + data,
    method: 'get',
    responseType: 'blob',
    fullResponse: true

  })
}
export const ApiMonthlyvenue = (data: any) => {
  return baseApiCall({
    url: bloomsvenue + data,
    method: 'get',
    responseType: 'blob',
    fullResponse: true

  })
}

export const ApiuploadDocuments = (data: any) => {
  return baseApiCall({
    url: uploadfiles,
    method: 'post',
    data,
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  })
}

export const ApiGetChecklist = (data: any) => {
  return baseApiCall({
    url: getChecklist + data,
    method: 'get',
  })
}

export const ApiCreateChecklist = (data: any) => {
  return baseApiCall({
    url: createChecklist,
    data,
    method: 'post',
  })
}
export const ApiCreateChecklistQuestion = (data: any) => {
  return baseApiCall({
    url: createChecklistQuestion,
    data,
    method: 'post',
  })
}
export const ApiUpdateChecklistQuestion = (data: any) => {
  return baseApiCall({
    url: updateChecklistQuestion,
    data,
    method: 'post',
  })
}
export const ApiDeleteChecklistQuestion = (data: any) => {
  return baseApiCall({
    url: deleteChecklistQuestion + data,
    method: 'Delete',
  });
}
export const ApiUpdateChecklist = (data: any) => {
  return baseApiCall({
    url: updateChecklist,
    method: 'put',
    data
  });
}
export const ApiDeleteChecklist = (data: any) => {
  return baseApiCall({
    url: deleteChecklist + data,
    method: 'Delete',
  });
}
export const ApiGetChecklistByVenueId = (data: any) => {
  return baseApiCall({
    url: venueChecklist + data,
    method: 'get',
  })
}

export const ApiGetVenueLogins = (data: any) => {
  return baseApiCall({
    url: veneuLogins + data,
    method: 'get'
  })
}
export const ApiCreateVenueLogins = (data: any) => {
  return baseApiCall({
    url: createveneuLogins,
    method: 'post',
    data
  })
}
export const ApiUpdateVenueLogins = (data: any) => {
  return baseApiCall({
    url: updateveneuLogins,
    method: 'put',
    data
  })
}
export const ApiGetVenueByVenueId = (data: any) => {
  return baseApiCall({
    url: venueByvenueId + data,
    method: 'get'
  })
}
export const ApiGetREgionListByClientEntity = (data: any) => {
  return baseApiCall({
    url: getRegionByClientEntity + data,
    method: 'get'
  })
}

export const ApiPutUpdateVenue = (data: any) => {
  return baseApiCall({
    url: putUpdateVenue,
    method: 'put',
    data
  })
}
export const ApiDeleteVenueLogins = (data: any) => {
  return baseApiCall({
    url: deletveneuLogins + data,
    method: 'del',
  })
}
export const ApiAnswerCheckListQuestion = (data: any) => {
  return baseApiCall({
    url: answeredQuestions,
    method: 'post',
    data
  });
}

export const ApiAddAreaManager = (data: any) => {
  return baseApiCall({
    url: postAreaManager,
    method: 'post',
    data
  })
}

export const ApiGetAreaManager = (data: any) => {
  return baseApiCall({
    url: getAreaManagers + data,
    method: 'get'
  })
}

export const ApiUpdateAreaManager = (data: any) => {
  return baseApiCall({
    url: putAreaManager,
    method: 'put',
    data
  })
}
export const ApiDeleteAreaManager = (data: any) => {
  return baseApiCall({
    url: deleteAreaManager,
    method: 'put',
    data
  })
}
export const ApiCreateFeedbackQuestions = (data: any) => {
  return baseApiCall({
    url: createfeedbackquestions,
    method: 'post',
    data
  })
}
export const ApiGetFeedbackQuestions = (data?: any) => {
  return baseApiCall({
    url: getfeedbackquestions + (data ? data : ''),
    method: 'get',
  })
}
export const ApiUpdateFeedbackQuestions = (data?: any) => {
  return baseApiCall({
    url: updatefeedbackquestions,
    method: 'post',
    data
  })
}
export const ApiSubmitFeedbackAnswers = (data?: any) => {
  return baseApiCall({
    url: submitfeedbackanswers,
    method: 'post',
    data
  })
}
export const ApiDownloadExcel = (data?: any) => {
  return baseApiCall({
    url: downloadexcel + data,
    method: 'get',
    responseType: 'blob',
    fullResponse: true

  })
}
export const ApiDownloadFeedbackExcel = (data?: any) => {
  return baseApiCall({
    url: downloadfeedbackexcel + data,
    method: 'get',
    responseType: 'blob',
    fullResponse: true

  })
}

export const ApiGenerateLoginToken = (data: any) => {
  return baseApiCall({
    url: generatelogintoken,
    method: 'post',
    data
  })
}

export const ApigetCategoryCmparisionReport = (data: any) => {
  return baseApiCall({
    url: categoryComparisionReport + data,
    method: 'get',
  })
}
export const ApigetSiteComparisionReport = (data: any) => {
  return baseApiCall({
    url: siteComparisionReport + data,
    method: 'get',
  })
}


export const ApiUpdateFixit = (data: any) => {
  return baseApiCall({
    url: updatefixit,
    method: 'put',
    data
  })
}
export const ApigetCategoryCmparisionExcel = (data: any) => {
  return baseApiCall({
    url: downloadcategoryexcel + data,
    method: 'get',
    responseType: 'blob',
    fullResponse: true
  })
}

export const ApideleteFeedbackQuestion = (data: any) => {
  return baseApiCall({
    url: deletefeedbackquestions + data,
    method: 'delete',
  })
}

export const ApiSubmitClientCommmet = (data: any) => {
  return baseApiCall({
    url: submitclientcomment,
    method: 'post',
    data
  })
}
export const ApiGetAnalytics = (data: any) => {
  return baseApiCall({
    url: chatboat,
    method: 'post',
    data,
    skipLoader:true
  })
}

export const ApigetCategoryWeeklyCmparisionReport = (data: any) => {
  return baseApiCall({
    url: categoryWeeklyComparisonReport + data,
    method: 'get',
  })
}

export const ApigetSiteWeeklyComparisionReport = (data: any) => {
  return baseApiCall({
    url: siteWeeklyComparisonReport + data,
    method: 'get',
  })
}


export const ApiGetBusinessChecklist = (data: any = "") => {
  return baseApiCall({
    url: getBusinessChecklist + data,
    method: 'get',
  })
}

export const ApiCreateBusinessChecklist = (data: any) => {
  return baseApiCall({
    url: createBusinessChecklist,
    method: 'post',
    data
  })
}

export const ApiUpdateBusinessChecklist = (data: any) => {
  return baseApiCall({
    url: updateBusinessChecklist,
    method: 'put',
    data
  })
}



export const ApiGetChecklistQuestions = (data:any="") => {
  return baseApiCall({
    url: getChecklistQuestions + data,
    method: 'get'
  })
}
export const ApiGetChecklistCategoryList = (data:any="") => {
  return baseApiCall({
    url: getChecklistCategorylist + data,
    method: 'get'
  })
}
export const ApiGetChecklistTemplate = (data:any="") => {
  return baseApiCall({
    url: getChecklistTemplateListing + data,
    method: 'get'
  })
}



export const ApiGetBusinessChecklistQuestions = (data:any="") => {
  return baseApiCall({
    url: getBusinessChecklistQuestions + data,
    method: 'get'
  })
}
export const ApiAddBusinessChecklistQuestion = (data: any) => {
  return baseApiCall({
    url: createBusinessChecklistQuestion,
    method: 'post',
    data
  })
}
export const ApiUpdateBusinessChecklistQuestion = (data: any) => {
  return baseApiCall({
    url: updateBusinesssChecklistQuestion,
    method: 'put',
    data
  })
}

export const ApiDeleteBusinessChecklistQuestion = (data: any) => {
  return baseApiCall({
    url: deleteBusinessChecklistQuestion + data,
    method: 'delete',
  })
}

export const ApiAddChecklistQuestion = (data: any) => {
  return baseApiCall({
    url: createChecklistQuestion,
    method: 'post',
    data
  })
}



export const ApiGetChecklistSubmissionQuestions = (data:any="") => {
  return baseApiCall({
    url: getCheklistSubmissionQuestions + data,
    method: 'get'
  })
}

export const ApiGetVenueManagerChecklistList = (data:any="") => {
  return baseApiCall({
    url: getVenueManagerCheklistList + data,
    method: 'get'
  })
}

export const ApiCreateChecklistSubmission = (data: any) => {
  return baseApiCall({
    url: createChecklistSubmission,
    method: 'post',
    data
  })
}

export const ApiSubmitVenueChecklist = (data: any) => {
  return baseApiCall({
    url: submitVenueChecklist,
    method: 'post',
    data
  })
}


export const ApiGetChecklistSubmissionList = (data:any="") => {
  return baseApiCall({
    url: getChecklistSubmissonList + data,
    method: 'get'
  })
}

export const ApiGetClientChecklistDashboard = (data:any="") => {
  return baseApiCall({
    url: getChecklistDashboard + data,
    method: 'get'
  })
}

export const ApiGetAreaChecklistDashboard = (data:any="") => {
  return baseApiCall({
    url: getAreaChecklistDashboard + data,
    method: 'get'
  })
}


export const ApiGetDashboardScoreByCategory = (data:any="") => {
  return baseApiCall({
    url: scorebyCategory + data,
    method: 'get'
  })
}
export const ApiGetDashboardScoreTrend = (data:any="") => {
  return baseApiCall({
    url: scoreTrend + data,
    method: 'get'
  })
}
export const ApiGetDashboardStarRatingSummary = (data:any="") => {
  return baseApiCall({
    url: starRatingSummary+ data,
    method: 'get'
  })
}
export const ApiGetDashboardLowestScoringQuestions = (data:any="") => {
  return baseApiCall({
    url: lowScoringQuestions + data,
    method: 'get'
  })
}


export const ApiGetDashboardTodayChecklist = (data:any="") => {
  return baseApiCall({
    url: duechecklist + data,
    method: 'get'
  })
}

export const ApiGetVenueDashboard = (data:any="") => {
  return baseApiCall({
    url: venueDashboard + data,
    method: 'get'
  })
}

export const ApiGetCategoryHeatMap = (data:any="") => {
  return baseApiCall({
    url: categoryHeatMap + data,
    method: 'get'
  })
}

export const ApiGetRecentReports = (data:any="") => {
  return baseApiCall({
    url: recentReports + data,
    method: 'get'
  })
}
export const ApiGetScoreDistribution = (data:any="") => {
  return baseApiCall({
    url: scoreDistribusion + data,
    method: 'get'
  })
}

export const ApiGetChecklistTemplateQuestions = (data:any="") => {
  return baseApiCall({
    url: checklisttemplatequestions + data,
    method: 'get'
  })
}

export const ApiGetChecklistPdf = (data:any="") => {
  return baseApiCall({
    url: checklistpdf + data,
    method: 'get',
    responseType: 'blob',
    fullResponse: true
  })
}

export const ApiGetNewVenuePdf = (data: any) => {
  return baseApiCall({
    url: newVenuePdf + data,
    method: 'get',
    responseType: 'blob',
    fullResponse: true

  })
}
export const ApiGetNewClientPdf = (data: any) => {
  return baseApiCall({
    url: newClientPdf + data,
    method: 'get',
    responseType: 'blob',
    fullResponse: true

  })
}
export const ApiGetNetPromoterScore = (data:any="") => {
  return baseApiCall({
    url: npsscore + data,
    method: 'get'
  })
}

export const ApiGetStarRatingAverage = (data:any="") => {
  return baseApiCall({
    url: starRatingAverage + data,
    method: 'get'
  })
}

export const ApiGetVenueLeaderBoard = (data:any="") => {
  return baseApiCall({
    url: venueLeaderBoard + data,
    method: 'get'
  })
}

export const ApiGetVenueLeaderBoardDetails = (data:any="") => {
  return baseApiCall({
    url: venueLeaderBoardDetails + data,
    method: 'get'
  })
}

export const ApiGetCategoryScores = (data:any="") => {
  return baseApiCall({
    url: categoryScores + data,
    method: 'get'
  })
}

export const ApiGetQuestionListForBusness = (data:any="") => {
  return baseApiCall({
    url: questionlistforBusiness + data,
    method: 'get'
  })
}

export const ApiCheckListCreation = (data:any="") => {
  return baseApiCall({
    url: checkListCreation + data,
    method: 'get'
  })
}

export const ApiGetResend2FA = (data: any) => {
  return baseApiCall({
    url: resend2FA,
    method: 'post',
    data
  })

}